/**
 * Drops focus from whatever element currently holds it, returning focus to the document body.
 *
 * Ionic keeps the outgoing page mounted during a route transition and marks it `ion-page-hidden`
 * + `aria-hidden="true"` while it animates out. If the control that triggered the navigation (a
 * button or link) still holds DOM focus inside that page, the browser blocks the aria-hidden and
 * warns: "Blocked aria-hidden on an element because its descendant retained focus." Dropping focus
 * at navigation start leaves nothing focused inside the soon-to-be-hidden page, so Ionic can move
 * focus to the incoming page cleanly. The same warning fires whenever focus is left inside any
 * subtree an overlay/transition marks aria-hidden.
 */
export function blurActiveElement(): void {
  const active = document.activeElement as HTMLElement | null;
  // `document.body` (or null) is the resting state — nothing meaningful to blur, and blurring the
  // body is a no-op we skip to keep the intent clear.
  if (active && active !== document.body && typeof active.blur === "function") {
    active.blur();
  }
}
